module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-video-d3285d686f7459d0372a229bafd78ed8.jpg";